<!-- <label [innerHtml]="question.question_prompt"></label> -->
<div class="form-group">
  @if (showLabel && (question?.question_prompt|| question?.email_version || labelText)) {
    <label class="form-group__label">
      {{useQuestionPromptLabel ? question?.question_prompt : question?.email_version ? question?.email_version : labelText}}
    </label>
  }
  <app-slider
    [ngClass]="{'disable-readonly': readOnly}"
    [question]="question"
    [sliderStep]="question?.interval ? question?.interval : 1 "
    [sliderMin]="question?.excess === 1 ? question?.min_val: 0"
    [sliderMax]="question?.excess === 1 ? question?.max_val: 0"
    [sliderInit]="+question?.answer"
    (slideUpdate)=saveSliderValue($event)>
  </app-slider>
</div>

